import { render, staticRenderFns } from "./objective-copy.vue?vue&type=template&id=cd8a64b8&"
import script from "./objective-copy.vue?vue&type=script&lang=ts&"
export * from "./objective-copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports